export default __webpack_public_path__ + "static/media/arrows.e8e1c1c5.svg";